/**
 * Kennungen als ULID (26 Zeichen, Crockford-Base32).
 *
 * Warum nicht Autoinkrement: Leitplanke 1 verlangt optimistische Updates ohne
 * Spinner. Der Client muss eine Aufgabe anlegen und sofort anzeigen können,
 * bevor der Server geantwortet hat – dafür braucht er die Kennung vorher.
 *
 * Warum nicht UUIDv4: ULIDs beginnen mit einem Zeitstempel und sind damit
 * sortierbar. Das hält die Einfügungen in InnoDB am Index-Ende statt sie
 * zufällig zu verteilen – bei MariaDB (E-10) wichtiger als bei Postgres.
 *
 * Ausnahme: `task_event` nutzt Autoinkrement. Ereignisse entstehen nur
 * serverseitig, und die Tabelle wird die größte des Systems – dort zählen
 * 8 Byte gegenüber 26 in jedem Sekundärindex.
 */
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ' // Crockford-Base32, ohne I L O U
const TIME_LENGTH = 10
const RANDOM_LENGTH = 16

function encodeTime(now: number): string {
  let out = ''
  let rest = now
  for (let i = TIME_LENGTH - 1; i >= 0; i--) {
    out = ENCODING[rest % 32] + out
    rest = Math.floor(rest / 32)
  }
  return out
}

function encodeRandom(): string {
  const bytes = new Uint8Array(RANDOM_LENGTH)
  crypto.getRandomValues(bytes)
  let out = ''
  for (const byte of bytes) out += ENCODING[byte % 32]
  return out
}

/** Erzeugt eine neue Kennung. Ohne Argument mit der aktuellen Zeit. */
export function newId(timestamp: number = Date.now()): string {
  return encodeTime(timestamp) + encodeRandom()
}

export const ID_LENGTH = TIME_LENGTH + RANDOM_LENGTH

const ID_PATTERN = new RegExp(`^[${ENCODING}]{${ID_LENGTH}}$`)

export function isValidId(value: string): boolean {
  return ID_PATTERN.test(value)
}

/** Liest den Zeitstempel aus einer Kennung – nützlich für Debugging. */
export function idTimestamp(id: string): Date {
  let time = 0
  for (const char of id.slice(0, TIME_LENGTH)) time = time * 32 + ENCODING.indexOf(char)
  return new Date(time)
}
